export default {
  banner: {
    description: 'Få {{range}} rabat, når du bestiller via den gratis FoodAmigos-app. Klik her for at hente appen →',
  },
  labels: {
    deals: 'Tilbud',
    collecting_points: 'Samler du allerede point?',
    earn_points: 'Optjen point og få belønninger ',
    order_again: 'Bestil igen',
  },
  checkout_button: {
    title: 'Gå til kurv',
  },
};
